import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { ParentAccountEditPage, ParentAccountDetailsPage, ParentPasswordUpdatePage } from 'pages';
import { AccountLayout } from 'components/layouts';

export const accountRoutes: RouteObject[] = [
    {
        path: appPaths.app.parent.account.base,
        element: <AccountLayout />,
        children: [
            {
                path: appPaths.app.parent.account.details.base,
                element: <ParentAccountDetailsPage />,
            },
            {
                path: appPaths.app.parent.account['password-update'],
                element: <ParentPasswordUpdatePage />,
            },
        ],
    },
    {
        path: appPaths.app.parent.account.details.edit,
        element: <ParentAccountEditPage />,
    },
];
